var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 37,
    viewBox: "0 0 29 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7506 30.758C13.4799 31.4899 14.6643 31.4899 15.3937 30.758L24.7291 21.3893C25.4584 20.6574 25.4584 19.4688 24.7291 18.7368C23.9998 18.0049 22.8153 18.0049 22.086 18.7368L15.9363 24.9143V6.9499C15.9363 5.9135 15.1019 5.07617 14.0692 5.07617C13.0365 5.07617 12.2021 5.9135 12.2021 6.9499V24.9084L6.0524 18.7427C5.32307 18.0108 4.13863 18.0108 3.4093 18.7427C2.67997 19.4746 2.67997 20.6633 3.4093 21.3952L12.7447 30.7639L12.7506 30.758Z",
    fill: "#0F6262"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 35.5,
    x2: 27.5,
    y2: 35.5,
    stroke: "#0F6262",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconDark);
export default __webpack_public_path__ + "static/media/download_icon_dark.e533730cc1e5bc58005cc0ee341d8760.svg";
export { ForwardRef as ReactComponent };